import { Events } from './events';
import { EventEmitter } from 'events';

export class InternetStatus extends EventEmitter {
	private onlineListener: () => void;
	private offlineListener: () => void;

	/** @ngInject */
	constructor (private $window: ng.IWindowService) {
		super();
		this.onlineListener = () => this.emit(Events.ONLINE);
		this.offlineListener = () => this.emit(Events.OFFLINE);
		this.$window.addEventListener(Events.ONLINE, this.onlineListener);
		this.$window.addEventListener(Events.OFFLINE, this.offlineListener);
	}

	public isOnline (): boolean {
		return this.$window.navigator.onLine;
	}

	public destroy (): void {
		this.$window.removeEventListener(Events.ONLINE, this.onlineListener);
		this.$window.removeEventListener(Events.OFFLINE, this.offlineListener);
		this.removeAllListeners();
	}
}
